export default "__VITE_ASSET__A2jTa2ip__"